<button type="button" class="button-custom hover-button" data-bs-toggle="tooltip" data-bs-placement="top"
    title="Click to show loader">
    tooltip & loader
</button>